// extracted by mini-css-extract-plugin
export default {"card":"CoachCard_card__N+Glj","image":"CoachCard_image__TmR10","overlay":"CoachCard_overlay__mUP9j"};